import React from 'react'

/**
 * Formats a time value for display in a grid cell.
 * @param {Object} rowData - The row data object
 * @param {string} field - The field name to format
 * @returns {string} Formatted time string in HH:mm format
 */
const TimeBodyTemplate = ({ rowData, field }) => {
    const timeValue = field ? rowData[field] : rowData.time
    return timeValue?.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit'
    }) || ''
}

export default TimeBodyTemplate
